"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _Icon = _interopRequireDefault(require("../../atoms/Icon"));
var _Typography = _interopRequireDefault(require("../../atoms/Typography"));
var _Column = _interopRequireDefault(require("../../layout/Column"));
var _ts = require("../../ts");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  inputStyles: '',
  inputLabel: '',
  helperTexts: [],
  onLoad() {}
};
function ImageInput(props) {
  const {
    size,
    inputStyles,
    inputLabel,
    helperTexts,
    onLoad,
    shape
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const {
    colors
  } = (0, _react2.useTheme)();
  const containerStyles = (0, _react.useMemo)(() => cssContainerStyles(inputStyles), [inputStyles]);
  const helpersStyles = (0, _react.useMemo)(() => cssHelpersStyles(size), [size]);
  return /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 25,
    styles: containerStyles
  }, /*#__PURE__*/_react.default.createElement(InputContainer, {
    onClick: onLoad,
    size: size,
    shape: shape
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "image",
    size: 24,
    color: "white"
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "helper",
    color: colors.FONT.CONTRAST,
    align: "center",
    children: inputLabel
  })), /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 10,
    styles: helpersStyles
  }, helperTexts === null || helperTexts === void 0 ? void 0 : helperTexts.map((text, index) => /*#__PURE__*/_react.default.createElement(_Typography.default, {
    key: index,
    type: "helper",
    color: "white",
    align: "center",
    children: text
  }))));
}
const cssContainerStyles = inputStyles => (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: rbga(0, 0, 0, .15);\n  ", "\n"])), inputStyles);
const InputContainer = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  \n  ", "\n"])), _ref => {
  let {
    size,
    shape
  } = _ref;
  let styles = "\n      width: ".concat(size.width, "px;\n      height: ").concat(size.height, "px;\n    ");
  if (shape === _ts.UIElementShapeEnum.Rect) {
    styles += "\n        border-radius: 10px;\n      ";
  } else if (shape === _ts.UIElementShapeEnum.Round) {
    styles += "\n      border-radius: ".concat(size.height, "px;\n    ");
  }
  return styles;
});
const cssHelpersStyles = size => (0, _react2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  max-width: ", "px;\n"])), size === null || size === void 0 ? void 0 : size.width);
var _default = exports.default = ImageInput;